
import { z } from "zod";

// Define the opportunity form schema
export const opportunitySchema = z.object({
  title: z.string().min(2, "Title must be at least 2 characters"),
  organization: z.string().min(2, "Organization name is required"),
  description: z.string().min(10, "Description must be at least 10 characters"),
  location: z.string().min(2, "Location is required"),
  deadline: z.string().min(1, "Application deadline is required"),
  opportunityType: z.string().min(1, "Type is required"),
  applicationUrl: z.string().url("Must be a valid URL"),
});

export type OpportunityFormValues = z.infer<typeof opportunitySchema>;
